try{self['workbox:sw:7.4.0']&&_()}catch(e){}// eslint-disable-line